<template>
    <div>
        <b-card header="사전예약 어드민 히스토리">

            <b-navbar>
                <b-nav pills>
                    <b-nav-item v-on:click="enrolledLogTypeFilterHandling(item)" :data-status=item.status :active="item.active" v-for="(item, index) in logType" :key="index"> {{item.text}}</b-nav-item>
                </b-nav>

                <b-navbar-nav class="ml-auto">
                    <b-form-group
                            label="검색"
                            label-for="enrolledAdminLog"
                            label-cols="3"
                            horizontal>
                        <b-form-input id="enrolledAdminLog" type="text" autocomplete="enrolledAdminLog" :placeholder="this.getSearchPlaceholder(this.currentLogType.searchType)" v-model="search"></b-form-input>
                    </b-form-group>
                </b-navbar-nav>
            </b-navbar>

            <b-table hover striped bordered responsive="sm" :items="this.filteredAdminHistory" :fields="pregAdminHistory.fields"  :current-page="currentPage" :per-page="perPage" :sort-by.sync="sortBy" :sort-desc=true
                     :show-empty=true empty-text="리스트가 없습니다.">
                <template slot="regTime" slot-scope="data">
                    {{ data.item.regTime ? data.item.regTime.format('YY.MM.DD HH:mm') : '-' }}
                </template>
                <template slot="adminUserId" slot-scope="data">
                    {{ data.item.adminUserId }}
                </template>
                <template slot="name" slot-scope="data">
                    {{ getPregNameOrId(getReqData(data.item)) }}
                </template>
                <template slot="adminApiUrl" slot-scope="data">
                    {{ getRequestDescription(data.item.adminApiUrl, data.item.apiMethod, getReqData(data.item)) }}
                    <b-link v-if="currentLogType.code==='preg'" :href="pregUrl + getReqData(data.item).permaUri" target="_blank">{{ getReqData(data.item).permaUri}}</b-link>
                </template>
                <template slot="info" slot-scope="data">
                    <b-button variant="outline-dark" @click="getAdminLogDetail(data.item.seq)">[보기]</b-button>
                </template>

            </b-table>
            <nav>
                <b-pagination :total-rows="pregAdminHistory.adminHistoryList.length" :per-page="perPage" v-model="currentPage" first-text="First" prev-text="Prev" next-text="Next" last-text="Last"/>
            </nav>
        </b-card>
        <b-modal v-model="modal.isShow" size="lg" title="요청/응답 메시지" ok-title="확인" ok-only centered no-close-on-esc no-close-on-backdrop hide-header-close @ok="modal.okHandling">
            {{ (modal.msg) ? modal.msg : '상세 정보가 없습니다' }}
        </b-modal>
    </div>
</template>

<script>
    import { FETCH_PREG_BATCH_HISTORY } from '@/store/preg/actions.type'
    import { $showModalWithErrorMsg, $getTypeName, $getMarketListString, $isInhouseLogin } from '@/common/util'
    import { SHOW_MODAL } from '@/store/ui/mutations.type'
    import PregService from '@/common/api/preg.service'
    import moment from 'moment'
    export default {
        name: "PregAdminHistory",

        data() {
            return {
                pregUrl: process.env.VUE_APP_PREG_URL,
                currentPage : 1,
                perPage : 10,
                sortBy : 'execution.startTime',
                selectedJob : null,
                modal: {
                    isShow: false,
                    msg: '',
                    okHandling: () => {
                    }
                },
                currentLogType : {
                    text: "로그인",
                    code: "login",
                    searchType : '사전예약 이름',
                    active: true
                },
                logType: [
                    {
                        text: "로그인",
                        code: "login",
                        searchType : '타입',
                        active: true
                    },
                    {
                        text: "사전예약",
                        code: "preg",
                        searchType : '사전예약 이름',
                        active: false
                    },
                    {
                        text: "사전예약 취소",
                        code: "deregisterPreg",
                        searchType : 'account id',
                        active: false
                    },
                    {
                        text: "계정 탈퇴",
                        code: "deregisterPgm",
                        searchType : 'account id',
                        active: false
                    }],
                search: '',
                pregAdminHistory : {
                    adminHistoryList: [],
                    fields: [
                        {key: 'regTime', label: '시간', class: 'align-middle text-center'},
                        {key: 'adminUserId', label: '이용자', class: 'align-middle text-center'},
                        {key: 'name', label: '사전예약', class: 'align-middle text-center'},
                        {key: 'adminApiUrl', label: '변경 내용', class: 'align-middle text-center'},
                        {key: 'info', label: '상세', class: 'align-middle text-center'}
                    ]
                }
            }
        },
        methods : {
            reqPregAdminHistory(logType) {
                PregService.reqPregAdminHistory(logType)
                    .then((res)=> {
                        this.pregAdminHistory.adminHistoryList = res.data.pregAdminLogList

                        for (let i = 0; i < this.pregAdminHistory.adminHistoryList.length; i++) {
                            this.pregAdminHistory.adminHistoryList[i].regTime = moment(this.pregAdminHistory.adminHistoryList[i].regTime)
                        }
                    }).catch($showModalWithErrorMsg.bind(this))

                this.currentPage = 1;

                this.search = ''
            },
            getRequestDescription(url, method, item) {

                if (url === '/v2/admin/pregs') return '사전예약 정보 등록'
                else if (url.startsWith('/v2/admin/pregs') && method ==='PUT') return '사전예약 정보 수정'
                else if (url === '/v2/admin/ldap') return 'ldap 로그인'
                else if (url === '/v2/admin/bis') return 'bis 로그인'
                else if (url.startsWith('/v2/admin/booker/')) return '사전예약 취소 - accountId: ' + item.accountId
                else if (url.startsWith('/v1/user/deregister')) return '계정 탈퇴 - accountId: ' + item.accountId
            },
            showInfo(message) {
                this.modal.msg = message
                this.modal.isShow = true
                this.modal.okHandling = () => {}
            },
            getReqData(item) {
                if (item.reqData != null) {
                    return item.reqData
                }

                return {}
            },
            getPregNameOrId(item) {
                if (this.currentLogType.code === 'preg') {
                    return item.name
                } else if (this.currentLogType.code === 'deregisterPreg') {
                    return item.pregMasterId
                } else {
                    return ''
                }
            },
            enrolledLogTypeFilterHandling (clickedItem) {
                const clickedIndex = this.logType.indexOf(clickedItem)
                for (let item of this.logType) {
                    item.active = false
                }
                this.logType[clickedIndex].active = true
                this.currentLogType = this.logType[clickedIndex]

                this.reqPregAdminHistory(this.currentLogType.code);
            },
            getSearchPlaceholder(item) {
                return 'admin id 혹은 ' + item + '으로 검색'
            },
            getAdminLogDetail(seq) {
                PregService.reqPregAdminLogDetail(seq)
                    .then((res)=> {
                        this.showInfo(res.data)
                    }).catch($showModalWithErrorMsg.bind(this))
            }
        },
        mounted() {
            this.currentLogType = this.logType[0]
            this.reqPregAdminHistory(this.currentLogType.code);
        },
        computed: {
            filteredAdminHistory() {
                return this.pregAdminHistory.adminHistoryList.filter(item => {
                    if (this.search === '') {
                        return true
                    }

                    let reqData = this.getReqData(item);

                    let result = false
                    if (reqData != null) {
                        if (this.currentLogType.code === 'login') {
                            result = item.adminApiUrl.toLowerCase().includes(this.search.toLowerCase())
                        } else if (this.currentLogType.code === 'preg') {
                            result = reqData.name.toLowerCase().includes(this.search.toLowerCase())
                        } else {
                            if (reqData.accountId != null) {
                                result = ("" + reqData.accountId).toLowerCase().includes(this.search.toLowerCase())
                            }
                        }

                    }
                    return result || item.adminUserId.toLowerCase().includes(this.search.toLowerCase())
                })
            }
        }
    }
</script>

<style scoped>

</style>
